'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AddressListItem = require('../AddressListItem');

var _AddressListItem2 = _interopRequireDefault(_AddressListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var string = _react.PropTypes.string,
    shape = _react.PropTypes.shape,
    arrayOf = _react.PropTypes.arrayOf,
    func = _react.PropTypes.func;
var AddressList = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AddressList, _React$Component);

  function AddressList() {
    (0, _classCallCheck3.default)(this, AddressList);
    return (0, _possibleConstructorReturn3.default)(this, (AddressList.__proto__ || (0, _getPrototypeOf2.default)(AddressList)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        this.props.addresses.map(function (address) {
          return _react2.default.createElement(_AddressListItem2.default, {
            selected: address.id === _this2.props.selectedAddressId,
            address: address,
            onEdit: _this2.props.onEdit(address.id),
            onDelete: _this2.props.onDelete(address.id),
            onChange: _this2.props.onChoice
          });
        })
      );
    }
  }]);
  return AddressList;
}(_react2.default.Component), _class.propTypes = {
  onEdit: func.isRequired,
  onDelete: func.isRequired,
  onChoice: func.isRequired,
  selectedAddressId: string.isRequired,
  addresses: arrayOf(shape({
    id: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    company: string.isRequired,
    address1: string.isRequired,
    address2: string.isRequired,
    city: string.isRequired,
    state: string.isRequired,
    postcode: string.isRequired
  }))
}, _temp);
exports.default = AddressList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressList/index.js
// module id = 2252
// module chunks = 0